import { combineReducers } from 'redux'

import detail from './detail/reducer';

export default combineReducers({
  detail,
})